export default {
    "user list": 'getUserList'
}



// WEBPACK FOOTER //
// ./src/script/usersParameters.js